import React, { useState, useCallback } from 'react'
import { StyleSheet, View, Text, ScrollView, Image, Alert, BackHandler } from 'react-native'
import { Button, Title, Description, Space, HorizontalLine, MenuList } from '@sart/components'
import { CompanyIcon } from '@sart/icons'
import { useContent } from '@sart/content'
import { testID } from '@sart/utilities'
import { useFocusEffect } from '@react-navigation/native';


import { SafeAreaView } from 'react-native-safe-area-context'

import { adaptive, backgroundColors, colors, typography } from '@sart/styles'
import NeedHelpFooter from '../NeedHelpFooter'


export default function RegisterHome(props) {
  const { navigation } = props

  const content = useContent()

 useFocusEffect(
   useCallback(() => {
     const onBackPress = () => {
       Alert.alert(
         'Exit Biker Mobile',
         'Do you want to exit?',
         [
           {
             text: 'Cancel',
             onPress: () => {},
             style: 'cancel',
           },
           { text: 'YES', onPress: () => BackHandler.exitApp() },
         ],
         { cancelable: false }
       )

       return true
     }

     const backHandler = BackHandler.addEventListener('hardwareBackPress', onBackPress)

     return () => {
       // cleanup when screen loses focus
       if (backHandler && backHandler.remove) backHandler.remove()
       else BackHandler.removeEventListener('hardwareBackPress', onBackPress)
     }
   }, [])
 )

  return (
    <SafeAreaView style={styles.container}>
      <ScrollView>
        <View style={styles.wrapper}>
          <Space height={48} />
          <View style={styles.logo}>
            <Image
                source={{ uri: 'https://shop.bikermobile.com/assets/biker_mobile_logo_final_nobg.png' }}
                height={styles.logoStyle.height} width={200} alignSelf={"center"}
            />
            {/* <CompanyIcon color={colors.white} height={styles.logoStyle.height} width={200} /> */}
          </View>
          <Space height={32} />
          <Title style={styles.title}>{content.registerHome.title}</Title>
          <Space height={16} />
          <Description style={styles.description}>{content.registerHome.description}</Description>
          <Description style={styles.description}>{content.registerHome.description2}</Description>
          <Space height={36} />
          <Button
            key={'login'}
            title={content.login.action}
            onPress={() => navigation.navigate('SignIn')}
            style={styles.button}
            titleStyle={styles.buttonTitle}
            {...testID('login')}
          />
          <Space height={12} />
          <Button
            key={'register'}
            title={content.registerHome.register}
            onPress={() => navigation.navigate('RegisterNumber')}
            style={styles.button}
            titleStyle={styles.buttonTitle}
            {...testID('register')}
          />
          <Space height={12} />
          {/* <Button
            key={'newSIM'}
            title={content.registerHome.newSIM}
            onPress={() => navigation.navigate('SignUpNewCustomerSim')}
            style={styles.button}
            titleStyle={styles.buttonTitle}
            {...testID('newSIM')}
          /> */}
        </View>
      </ScrollView>
    </SafeAreaView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: backgroundColors.darkCharcoal,
    ...adaptive.wrapperPadding
  },
  wrapper: {
    flex: 1
  },
  title: {
    color: colors.white,
    fontSize: 22,
    ...typography.extrabold
  },
  link: {
    paddingTop: 5,
    textAlign: 'center',
    ...typography.demi,
    color: colors.white
  },
  menuListItemStyle: {
    fontSize: 18,
    ...typography.lightbold,
    color: colors.black
  },
  logo: {
    alignSelf: 'center'
  },
  description: {
    color: colors.white,
    textAlign: 'center',
    ...typography.demi,
  },
  button: {
    backgroundColor: colors.brightOrange,
  },
  buttonTitle: {
    fontSize: 18,
    ...typography.extrabold
  },
  logoStyle: {
    ...adaptive.guruSize
  },
})
